import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header/Header';
import Banner from '../components/Banner/Banner';
import Service from '../components/Service/Service';
import Footer from '../components/Footer/Footer';

const Rate = lazy(() => import('../components/Rate/Rate'));
const Girl = lazy(() => import('../components/Girl/Girl'));
const Promos = lazy(() => import('../components/Promos/Promos'));
const About = lazy(() => import('../components/About/About'));
const Gallery = lazy(() => import('../components/Gallery/Gallery'));
const Legal = lazy(() => import('../components/Legal/Legal'));
const SITE_URL = 'https://www.oceannoir.au';

const HomePage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isEnPage = location.pathname === '/en';
  const canonical = `${SITE_URL}${isEnPage ? '/en' : '/'}`;
  const pageLocale = isEnPage ? 'en_AU' : 'zh_CN';
  const businessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#business`,
    name: 'Ocean Noir',
    url: SITE_URL,
    image: `${SITE_URL}/logo.png`,
    description: t('hero.subline'),
    areaServed: {
      '@type': 'City',
      name: 'Sydney',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '578 Harris Street',
      addressLocality: 'Ultimo',
      addressRegion: 'NSW',
      postalCode: '2007',
      addressCountry: 'AU',
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+61-426-945-499',
        contactType: 'customer service',
        availableLanguage: ['zh', 'en'],
      },
      {
        '@type': 'ContactPoint',
        email: 'oceannoir580@gmail.com',
        contactType: 'customer support',
        availableLanguage: ['zh', 'en'],
      },
    ],
  };
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: 'Ocean Noir',
    url: SITE_URL,
    inLanguage: ['zh', 'en'],
  };

  return (
    <>
      <Helmet>
        <title>Ocean Noir | Sydney Luxury Sensory Entertainment</title>
        <meta name="description" content={t('hero.subline')} />
        <meta property="og:locale" content={pageLocale} />
        <meta property="og:site_name" content="Ocean Noir" />
        <link rel="canonical" href={canonical} />
        <link rel="alternate" hrefLang="zh" href={`${SITE_URL}/`} />
        <link rel="alternate" hrefLang="en" href={`${SITE_URL}/en`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/`} />
        <script type="application/ld+json">
          {JSON.stringify(businessSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
      </Helmet>
      <Header />
      <main>
        <Banner />
        <Service />
        <Suspense fallback={null}>
          <Rate />
          <Girl />
          <Promos />
          <About />
          <Gallery />
          <Legal />
        </Suspense>
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
